module.exports = __webpack_public_path__ + "img/sucot-2015.ef35d632.jpg";